import React from "react";

export const SwipeFiltersContext = React.createContext<
  | {
      swipeActiveRef: React.RefObject<boolean>;
    }
  | undefined
>(undefined);
